import { useContext } from "react"
import { MapContext } from "../MapContextProvider"
import DeviceList from "./DeviceList/DeviceList"
import { SidebarNoForm } from "components/sidedrawer/SidebarNoForm"
import { faMap } from "@fortawesome/pro-solid-svg-icons"
import { useTranslation } from "react-i18next"

const DeviceBar = (props) => {
  const { t } = useTranslation()
  const { labelMapCardSetting } = { ...props }
  const { devices } = useContext(MapContext)

  return (
    <SidebarNoForm
      childrenWrapperSx={{ display: "flex", flexDirection: "column" }}
      flexDirection="row"
      formData={{
        titleNew: t("map.map", "Map"),
        subTitleNew: t("map.inspect_your_vehicles", "Inspect your vehicles"),
        icon: faMap
      }}>
      <DeviceList devices={devices} labelMapCardSetting={labelMapCardSetting} />
    </SidebarNoForm>
  )
}
export default DeviceBar
